export default "__VITE_PUBLIC_ASSET__54050efb__"